<template>
    <div>
        <router-view></router-view>
        <van-tabbar route>
            <van-tabbar-item to="/home" icon="home-o">首页</van-tabbar-item>
            <van-tabbar-item to="/appointment" icon="calendar-o">预约</van-tabbar-item>
            <!-- <van-tabbar-item to="/manager" icon="setting-o">管理</van-tabbar-item> -->
            <van-tabbar-item to="/user" icon="manager-o">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
  name: 'LayoutIndex'
}
</script>

<style>
</style>
